/* eslint-disable @nx/enforce-module-boundaries */
import { DebtType } from '@axo/shared/data-access/types';
import { useTranslation } from '@axo/shared/i18n';
import { getFormattedAmountUI } from '@axo/shared/util/formatters';
import { Stack } from '@axo/ui-core/components/layout/item';
import { Text } from '@axo/ui-core/components/typography';
import { FocusEvent, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import styles from './debtDetails.module.scss';
import { MonthlyDebtPaymentField, TypeField } from './fields';

export const IdleDebtDetails = ({ index }: { index: number }) => {
  const { watch } = useFormContext();

  const creditor = watch(`LoanApplication/Debts.${index}.Creditor`);

  const type = watch(`LoanApplication/Debts.${index}.Type`);

  const outstandingAmount = watch(
    `LoanApplication/Debts.${index}.OutstandingAmount`
  );

  const monthlyDebtPayment = watch(
    `LoanApplication/Debts.${index}.MonthlyDebtPayment`
  );

  const [monthlyPaymentFilled, setMonthlyPaymentFilled] = useState(
    !!monthlyDebtPayment
  );

  const { t } = useTranslation();

  const text = creditor ? creditor : t('Debt.OutstandingAmount.title');

  const onBlur = (e: FocusEvent<HTMLInputElement>) => {
    if (!e.target.value) return;
    if (Number(e.target.value) < 100) return;
    setMonthlyPaymentFilled(true);
  };

  const askDebtType = type === DebtType.Unspecified;

  return (
    <Stack gap="3xs" className={styles.fullWidth}>
      <div className={styles.idleDebtInfo}>
        <Text>
          <b>{text}</b>
        </Text>
        <Text>
          <b>
            {getFormattedAmountUI(outstandingAmount)} {t('suffix.currency')}
          </b>
        </Text>
      </div>

      {monthlyPaymentFilled && (
        <div className={styles.idleDebtInfo}>
          <Text>{t('Debt.MonthlyDebtPayment.label')}</Text>
          <Text>
            {getFormattedAmountUI(monthlyDebtPayment)} {t('suffix.currency')}
          </Text>
        </div>
      )}

      {!monthlyPaymentFilled && (
        <MonthlyDebtPaymentField index={index} onBlur={onBlur} />
      )}
      {askDebtType && (
        <div className={styles.typeFieldContainer}>
          <TypeField index={index} />
        </div>
      )}
    </Stack>
  );
};
